module.exports = __webpack_public_path__ + "static/33-792798b4c1f1554dfd377ec129f6ffe6.png";